Wee.fn.make('options', {
	init: function() {
		var priv = this.$private,
			segment = Wee.routes.uri().segments[1];

		if ($('ref:weeDropdown').length) {
			Wee.dropdown.init({
				placeholder: segment === 'shade' || segment === 'shelters' ?
					'<div class="dropdown__placeholder">Choose an option</div>' : false,
				rootModifier: segment === 'shade' || segment === 'shelters' ? '-shadeShelter' : false,
				isSelected: segment === 'shade' || segment === 'shelters' ? false : true,
				activeClass: '-is-active'
			});
		}

		priv.initEvents();

		if ($('ref:recycledOptions').length || $('ref:woodOptions').length) {
			priv.toggleOptions();
		}
	},

	unload: function() {
		$.events.off(false, '.productOptions');
	}
}, {
	initEvents: function() {
		var scope = this;

		$.events.on({
			'ref:toggle': {
				click: function(e, el) {
					var $extraOptions = $('ref:extraOptions'),
						$el = $(el);

					$el.closest($extraOptions).isActive() ?
						$el.text('See more').closest($extraOptions).deactivate() :
						$el.text('See less').closest($extraOptions).activate();
				}
			},
			'ref:swatchOption': {
				click: function(e, el) {
					var $option = $(el),
						text = $option.attr('data-title');

					$option.closest('ref:extraOptions')
						.find('ref:selectedSwatch')
						.text(text);
				}
			},

			'ref:productFinish': {
				click: function() {
					scope.toggleOptions();
				}
			}
		}, {
			namespace: 'productOptions'
		});
	},

	/**
	 * Show or hide swatches based on product finish
	 *
	 * @private
	 */
	toggleOptions: function() {
		var selectedFinish = $('input:checked[name="productFinish').val(),
			$recycledOptions = $('ref:recycledOptions'),
			$woodOptions = $('ref:woodOptions');

		if (selectedFinish === '100-recycled' || selectedFinish === 'recycled-plastic') {
			$recycledOptions.show();
		} else {
			$recycledOptions.hide();
		}

		if (selectedFinish === 'wood') {
			$woodOptions.show();
		} else {
			$woodOptions.hide();
		}
	}
});